import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_TEMPLATES ({ commit }, { formData }) {
    const tableType = formData

    const query = `query devExpress_Templates (
      $where: DevExpress_TemplateFilterInput
      $order: [DevExpress_TemplateSortInput!]
    ) {
      response: devExpress_Templates (where: $where order: $order) {
          field_001
          title
          state
          table_type
          creator
          deleted
      }
    }`

    const variables = {
      where: {
        deleted: { neq: 1 },
        table_type: { eq: tableType }
      },
      order: {
        title: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
        commit('SET_TEMPLATES', data.data.response)
    }

    return data
  },

  async GET_TEMPLATES_SEARCHQUERY ({ commit }) {
    const query = `query devExpress_Templates (
      $where: DevExpress_TemplateFilterInput
      $order: [DevExpress_TemplateSortInput!]
    ) {
      response: devExpress_Templates (where: $where order: $order) {
          field_001
          title
          state
          table_type
          creator
          deleted
      }
    }`

    const variables = {
      where: {
        deleted: { neq: 1 },
        table_type: { eq: 6 }
      },
      order: {
        title: 'ASC'
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
        commit('SET_TEMPLATES_SEARCHQUERY', data.data.response)
    }

    return data
  },

  async CREATE_TEMPLATE ({ commit }, { formData }) {
      const {
        state,
        title,
        creator,
        table_type /* eslint-disable-line */
      } = formData

      const query = `mutation createDevExpress_Template ($input: CreateDevExpress_TemplateInput) {
        createDevExpress_Template(input: $input) {
          devExpress_Template {
            field_001
            title
          }
        }
      }`

      const variables = {
        input: {
          state: state,
          title: title,
          creator: creator,
          table_type: table_type
        }
      }

      const { data } = await gql({ query, variables })

      return data
    },

    async GET_TEMPLATE_BY_TITLE ({ commit }, { formData }) {
      const {
        field_001, /* eslint-disable-line */
        title,
        table_type /* eslint-disable-line */
      } = formData

      const query = `query devExpress_Templates (
        $where: DevExpress_TemplateFilterInput
      ) {
        response: devExpress_Templates (where:$where) {
          field_001
          title
          state
          table_type
          creator
          deleted
        }
      }`

      let variables

      if (field_001) { /* eslint-disable-line */
        variables = {
          where: {
            title: { eq: title.trim() },
            deleted: { neq: 1 },
            table_type: { eq: table_type },
            field_001: { neq: field_001 }
          }
        }
      } else {
        variables = {
          where: {
            title: { eq: title.trim() },
            deleted: { neq: 1 },
            table_type: { eq: table_type }
          }
        }
      }

      const { data } = await gql({ query, variables })

      if (!data.errors) {
        commit('SET_MATCHING_TEMPLATES', data.data.response)
      }

      return data
    },

    async UPDATE_TEMPLATE ({ commit }, { formData }) {
      const {
        id,
        state
      } = formData

      const query = `mutation updateDevExpress_Template ($input: UpdateDevExpress_TemplateInput!) {
        updateDevExpress_Template(input: $input) {
          devExpress_Template {
            field_001
            title
          }
        }
      }`

      const variables = {
        input: {
          field_001: id,
          state: state
        }
      }

      const { data } = await gql({ query, variables })

      return data
    },

    async DELETE_TEMPLATE ({ commit }, { formData }) {
      const id = formData

      const query = `mutation updateDevExpress_Template ($input: UpdateDevExpress_TemplateInput!) {
        updateDevExpress_Template(input: $input) {
          devExpress_Template {
            field_001
            title
          }
        }
      }`

      const variables = {
        input: {
          field_001: id,
          deleted: 1
        }
      }

      const { data } = await gql({ query, variables })

      return data
    },

    async EDIT_TEMPLATE ({ commit }, { formData }) {
      const {
        field_001, /* eslint-disable-line */
        title
      } = formData

      const query = `mutation updateDevExpress_Template ($input: UpdateDevExpress_TemplateInput!) {
        updateDevExpress_Template(input: $input) {
          devExpress_Template {
            field_001
            title
          }
        }
      }`

      const variables = {
        input: {
          field_001: field_001,
          title: title
        }
      }

      const { data } = await gql({ query, variables })

      return data
    }
}
